import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {FormBuilder, Validators} from '@angular/forms';
import {StockDataSourceService} from '../../../core/data-sources/stock-data-source.service';
import {TaskRequestSidenavService} from '../../../core/services/task-request-sidenav.service';
import {ActionService} from '../../../core/services/action.service';

@Component({
  selector: 'app-stock-pending-expedition-sidenav',
  templateUrl: './stock-pending-expedition-sidenav.component.html',
  styleUrls: ['./stock-pending-expedition-sidenav.component.scss']
})
export class StockPendingExpeditionSidenavComponent implements OnInit, OnDestroy, OnChanges {

  @Input() drawer;
  @Input() task;

  usersHighlighted = [];
  productInputSubscription: Subscription;
  resetInputSubscription: Subscription;
  products;
  isProductChosen = false;
  relocateForm;
  selectOperatorError = false;
  isSectorSelected: boolean = false;
  destinationData = null;

  constructor(private stockService: StockDataSourceService,
              private formBuilder: FormBuilder,
              private sidenavService: TaskRequestSidenavService,
              private actionService: ActionService) {
    this.buildForm();
  }

  async ngOnInit() {
    this.productInputSubscription = this.relocateForm.controls.product.valueChanges.pipe(debounceTime(250))
      .subscribe(async (newValue) => {
        this.products = await this.stockService.getSearchedProducts(newValue);
        if (newValue?.sku) {
          this.isProductChosen = true;
        }
      });
    this.resetInputSubscription = this.relocateForm.controls.product.valueChanges.subscribe(() => {
      if (this.isProductChosen) {
        this.isProductChosen = false;
        this.relocateForm.controls.product.reset();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.task.currentValue) {
      this.relocateForm.controls.rfid.setValue(changes.task.currentValue.data.tagRfid);
      this.relocateForm.controls.product.setValue(changes.task.currentValue.data.products[0]);
    }
  }

  ngOnDestroy() {
    this.productInputSubscription.unsubscribe();
    this.resetInputSubscription.unsubscribe();
  }

  buildForm() {
    this.relocateForm = this.formBuilder.group({
      product: ['', Validators.required],
      rfid: ['', Validators.required],
    });
  }

  setUsers(users) {
    this.usersHighlighted = users;
  }

  displayedString(product) {
    if (product) {
      return product.name + ' - ' + product.sku;
    } else {
      return null;
    }
  }

  async sendTask() {
    const { data: destination } = this.destinationData;
    const params = {
      type: 'RELOCATE_EXPEDITION',
      userIds: this.usersHighlighted,
      tagRfid: this.relocateForm.controls.rfid.value,
      taskData: {
        outOrderNumber: '',
        destination: {
          x: destination.address.x,
          y: destination.address.y,
          z: destination.level.z
        },
        showGreenScreen: this.destinationData.data.showGreenScreen,
      }
    };
    await this.actionService.relocateExpedition(params);
  }

  submit() {
    this.relocateForm.markAllAsTouched();
    if (this.relocateForm.valid && this.usersHighlighted.length) {
      this.sendTask();
      this.selectOperatorError = false;
      this.drawer.close();
      this.sidenavService.closeSidenav(true);
      this.resetForm();
    } else {
      this.selectOperatorError = true;
    }
  }

  close() {
    this.drawer.close();
    this.sidenavService.closeSidenav(false);
    this.resetForm();
  }

  resetForm() {
    this.relocateForm.reset();
    this.usersHighlighted = [];
    this.selectOperatorError = false;
  }

  destinationDataChanged(event) {
    this.destinationData = event;
  }
  
}
